import { createSlice } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { createBasicInfo } from './api/createBasicInfo'
import { createDefaultBasicInfo } from './api/createDefaultBasicInfo'
import { requestBasicInfoData } from './api/requestBasicInfoData'
import { updateBasicInfo } from './api/updateBasicInfo'
import { updateDefaultBasicInfo } from './api/updateDefaultBasicInfo'
import { initialState } from './configs'
import { PARTNER360_BASIC_INFO_NAMESPACE } from './constants'

const basicInfoSlice = createSlice({
  name: PARTNER360_BASIC_INFO_NAMESPACE,
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(requestBasicInfoData.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'fetching basicInfo data...'
      })
      .addCase(requestBasicInfoData.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestBasicInfoData.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'basicInfo data fetched successful'

        if (action.payload) {
          state.createdData = action.payload.createdData
          state.defaultData = action.payload.defaultData
        }
      })

      .addCase(createBasicInfo.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'creating basicInfo data...'
      })
      .addCase(createBasicInfo.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(createBasicInfo.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        if (action.payload) {
          state.createdData = action.payload
        }
      })

      .addCase(updateBasicInfo.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'updating basicInfo data...'
      })
      .addCase(updateBasicInfo.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(updateBasicInfo.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'basicInfo data updated successful'

        if (action.payload) {
          state.createdData = action.payload
        }
      })

      .addCase(createDefaultBasicInfo.pending, (state) => {
        state.message = 'creating defaultBasicInfo data...'
      })
      .addCase(createDefaultBasicInfo.rejected, (state, action) => {
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(createDefaultBasicInfo.fulfilled, (state, action) => {
        if (action.payload) {
          state.defaultData = action.payload
        }
      })

      .addCase(updateDefaultBasicInfo.pending, (state) => {
        state.message = 'updating defaultBasicInfo data...'
      })
      .addCase(updateDefaultBasicInfo.rejected, (state, action) => {
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(updateDefaultBasicInfo.fulfilled, (state, action) => {
        if (action.payload) {
          state.defaultData = action.payload
          state.message = 'defaultBasicInfo data updated successful'
        }
      }),
})

export default basicInfoSlice.reducer
